'use client';

import StatCard from './StatCard';
import { Users, Award, Package, Shield } from 'lucide-react';

export default function CompanyStats() {
  const stats = [
    {
      id: 1,
      number: '+300',
      label: 'Clients satisfaits',
      icon: Users,
    },
    {
      id: 2,
      number: '98%',
      label: 'Taux de satisfaction',
      icon: Award,
    },
    {
      id: 3,
      number: '+100',
      label: 'Produits disponibles',
      icon: Package,
    },
    {
      id: 4,
      number: '12 mois',
      label: 'Garantie incluse',
      icon: Shield,
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-linear-to-r from-[#23994F] to-[#1a7840] relative overflow-hidden">

      <div className="absolute -top-20 -right-20 w-60 h-60 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-white/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {stats.map((stat, idx) => (
            <div key={stat.id} style={{ animationDelay: `${idx * 0.1}s` }} className="stagger-item">
              <StatCard {...stat} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
